module.exports = __webpack_public_path__ + "static/media/AC04003W_03.cbaf6f5e.png";